module.exports = __webpack_public_path__ + "img/4.4c0fb4c6.png";